import { render, staticRenderFns } from "./ReturnShipmentCompleteModal.vue?vue&type=template&id=1ea70d0b&scoped=true&"
import script from "./ReturnShipmentCompleteModal.vue?vue&type=script&lang=js&"
export * from "./ReturnShipmentCompleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea70d0b",
  null
  
)

export default component.exports